import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { Container } from './ui/Container';
import { SectionTag } from './ui/SectionTag';
import { faqItems } from '../data/faq';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-mp-dark py-20 md:py-28" data-id="element-95" data-mp="1ntzwd4buliz7">
      <Container data-id="element-96" data-mp="1nwvvgvzfmdp8">
        <div className="mx-auto max-w-[700px] text-center" data-id="element-97" data-mp="2bkcbp09fahzt">
          <SectionTag tone="lime" data-id="element-98" data-mp="2bkvvkmimvggh">Preguntas frecuentes</SectionTag>
          <h2 className="mt-5 font-heading text-3xl uppercase leading-tight text-mp-white sm:text-4xl" data-id="element-99" data-mp="2fm7ek97053fp">
            Todo lo que necesitas saber
          </h2>
        </div>

        <div className="mx-auto mt-10 max-w-[750px] divide-y divide-mp-border rounded-2xl border border-mp-border bg-mp-card" data-id="element-100" data-mp="26tningi3hcyk">
          {faqItems.map((item, index) => {
          const isOpen = openIndex === index;
          return <div key={item.question} data-id="element-101" data-mp="2zaq62xfhcsxk" data-mpi={index}>
                <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left md:px-7" data-id="element-102" data-mp="2zbrltf7fy3lm">
                  <span className="font-heading text-sm uppercase tracking-wide text-mp-white md:text-base" data-id="element-103" data-mp="25hniuzyttt3t">
                    {item.question}
                  </span>
                  <ChevronDownIcon className={`h-5 w-5 flex-shrink-0 text-mp-lime transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} data-id="element-104" data-mp="2fcfmolj05c71" />
                </button>
                <div className={`grid transition-[grid-template-rows] duration-200 ease-out ${isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`} data-id="element-105" data-mp="2jeu3z170w3w7">
                  <div className="overflow-hidden" data-id="element-106" data-mp="p2dyw3pyqvsx">
                    <div className="space-y-2 px-5 pb-5 text-sm leading-relaxed text-mp-gray md:px-7 md:text-[15px]" data-id="element-107" data-mp="2p3k88rprxhir">
                      {item.answer.map((p, i) => <p key={i} data-id="element-108" data-mp="2u2x4g32jc0y0" data-mpi={i}>{p}</p>)}
                    </div>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </Container>
    </section>;
}